import React from 'react';
import LCVProgressTracker from './LCVProgressTracker';
import LCVStageTable from './LCVStageTable';
import LCVTopBar from './LCVTopBar';
import LCVTutorPanel from './LCVTutorPanel';
import LCVViewBoard from './LCVViewBoard';

const LCVStaticLessonStage = ({
  metadata,
  progressData,
  phase,
  activeTerm,
  middleContent,
  tutorText,
  tutorAnimationProgress,
  tutorWordTimings = null,
  tutorCurrentTimeMs = 0,
  tutorPaused = false,
  canPauseTutor = false,
  canSkipTutor = false,
  tutorFontSize,
  onTutorFontSizeChange,
  onPauseTutor,
  onResumeTutor,
  onSkipTutor,
  onReplayTutor,
  playbackRate = 1,
  canIncreasePlaybackRate = false,
  canDecreasePlaybackRate = false,
  onIncreasePlaybackRate,
  onDecreasePlaybackRate,
  volume = 100,
  canIncreaseVolume = false,
  canDecreaseVolume = false,
  onIncreaseVolume,
  onDecreaseVolume,
  isMuted = false,
  onToggleMute,
  canReplayTutor = false,
  trackerMode,
  visualContent,
  tutorPlaybackFinished = false,
  onNavigateTracker,
}) => {
  if (!progressData || !middleContent) return null;

  return (
    <LCVStageTable
      className="lcv-stage-table-static"
      topLeft={<LCVTopBar metadata={metadata} />}
      topCenter={
        <LCVProgressTracker
          data={progressData}
          phase={phase}
          mode={trackerMode}
          onNavigate={onNavigateTracker}
        />
      }
      topRight={<div className="lcv-stage-empty" />}
      middleLeft={
        visualContent ? (
          <LCVViewBoard phase={phase} term={activeTerm} visualContent={visualContent} />
        ) : (
          <div className="lcv-stage-empty" />
        )
      }
      middleCenter={<div className="lcv-stage-middle-shell">{middleContent}</div>}
      middleRight={<div className="lcv-stage-empty" />}
      bottomLeft={<div className="lcv-stage-empty" />}
      bottom={
        tutorText ? (
          <LCVTutorPanel
            text={tutorText}
            phase={phase}
            animationProgress={tutorAnimationProgress}
            wordTimings={tutorWordTimings}
            currentTimeMs={tutorCurrentTimeMs}
            paused={tutorPaused}
            canPause={canPauseTutor}
            canSkip={canSkipTutor}
            fontSize={tutorFontSize}
            onFontSizeChange={onTutorFontSizeChange}
            onPause={onPauseTutor}
            onResume={onResumeTutor}
            onSkip={onSkipTutor}
            onReplay={onReplayTutor}
            canReplay={canReplayTutor}
            playbackRate={playbackRate}
            canIncreasePlaybackRate={canIncreasePlaybackRate}
            canDecreasePlaybackRate={canDecreasePlaybackRate}
            onIncreasePlaybackRate={onIncreasePlaybackRate}
            onDecreasePlaybackRate={onDecreasePlaybackRate}
            volume={volume}
            canIncreaseVolume={canIncreaseVolume}
            canDecreaseVolume={canDecreaseVolume}
            onIncreaseVolume={onIncreaseVolume}
            onDecreaseVolume={onDecreaseVolume}
            isMuted={isMuted}
            onToggleMute={onToggleMute}
            playbackFinished={tutorPlaybackFinished}
          />
        ) : (
          <div className="lcv-stage-empty" />
        )
      }
    />
  );
};

export default LCVStaticLessonStage;
